/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { CREATE_UTILITY_CENTER } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { StorageModule } from "@vlinder-web/storage-module-react";

const log: any = LoggerModule?.getInstance();

const storageService = StorageModule.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICreateUtilityCenterMethods extends IPluginMethodMap {
  createUtilityCenter(args: any): Promise<any>;
}

export class CreateUtilityCenterService implements IAgentPlugin {
  readonly methods: ICreateUtilityCenterMethods;

  constructor() {
    this.methods = {
      createUtilityCenter: this.createUtilityCenter.bind(this),
    };
  }

  async createUtilityCenter(args: any) {
    log.blue(`createUtilityCenter server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      // return {...config}
      if (client) {
        const res = await client.mutate({
          mutation: CREATE_UTILITY_CENTER,
          variables: {
            data: {
              ...args?.payload,
              band:
                storageService.get("bandConfig", "local")?.band?.appCardId ??
                null,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.createUtilityCent,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      throw err;
      // /return err;
      // return {
      //   isEmpty: true,
      // };
    }
  }
}
